<template>
  <div>
    <Head title="Herramientas del sistema" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/">Cuenta</Link>
      <span class="text-indigo-400 font-medium">/</span>
      Herramientas
    </h1>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mb-8">
      <div class="p-8 border-b border-gray-100">
        <h2 class="text-xl font-bold text-gray-800 mb-2">Reiniciar Ventas y Balances de Clientes</h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          Esta función elimina todas las ventas y cobros registrados (<code class="bg-gray-100 px-1 py-0.5 rounded text-red-600 font-mono">Order</code>, <code class="bg-gray-100 px-1 py-0.5 rounded text-red-600 font-mono">OrderPay</code>, <code class="bg-gray-100 px-1 py-0.5 rounded text-red-600 font-mono">OrderProduct</code>, despachos y facturación vinculada) y restablece a cero (0) el balance de todos los propietarios/clientes.
        </p>

        <div class="mt-4 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 text-sm rounded">
          <p class="font-bold flex items-center">
            <span class="material-icons-outlined mr-2">warning</span>
            ¡Atención! Acción irreversible
          </p>
          <p class="mt-1">
            Una vez ejecutado este proceso, todos los registros de ventas y cobros serán eliminados permanentemente y no se podrán recuperar.
          </p>
        </div>
      </div>

      <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
        <span class="text-xs text-gray-500">Solo administradores</span>
        <button 
          type="button" 
          class="flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-md transition shadow-sm"
          @click="confirmReset"
          :disabled="form.processing"
        >
          <span class="material-icons-outlined mr-1 text-base">delete_forever</span>
          Eliminar Ventas y Resetear Balances
        </button>
      </div>
    </div>

    <!-- Modal de confirmación -->
    <div v-if="showModal" class="fixed inset-0 z-50 overflow-y-auto bg-black/50 flex items-center justify-center p-4">
      <div class="bg-white rounded-lg max-w-md w-full p-6 shadow-xl relative">
        <h3 class="text-lg font-bold text-gray-900 mb-2">¿Confirmar reinicio de ventas y balances?</h3>
        <p class="text-sm text-gray-600 mb-4">
          Se eliminarán todas las ventas y se colocará en cero (0) el saldo de todos los clientes. Escriba <strong class="text-red-600 font-mono">CONFIRMAR</strong> para proceder.
        </p>

        <input 
          v-model="confirmationText"
          type="text" 
          placeholder="Escriba CONFIRMAR"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 mb-4 font-mono text-sm"
        />

        <div class="flex justify-end space-x-3">
          <button 
            type="button"
            class="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 text-sm font-medium"
            @click="closeModal"
          >
            Cancelar
          </button>
          <loading-button 
            :loading="form.processing" 
            :disabled="confirmationText !== 'CONFIRMAR'" 
            class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium disabled:opacity-50"
            @click="submitReset"
          >
            Confirmar y Borrar
          </loading-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  layout: Layout,
  components: {
    Head,
    Link,
    LoadingButton,
  },
  data() {
    return {
      showModal: false,
      confirmationText: '',
      form: this.$inertia.form({}),
    }
  },
  methods: {
    confirmReset() {
      this.confirmationText = ''
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.confirmationText = ''
    },
    submitReset() {
      if (this.confirmationText !== 'CONFIRMAR') return

      this.form.post('/tools/reset-orders', {
        onSuccess: () => {
          this.closeModal()
        },
      })
    },
  },
}
</script>
